// extracted by mini-css-extract-plugin
export var heroSection = "hero-module--heroSection--wMfRF";
export var shade = "hero-module--shade--PjpsC";
export var heroImage = "hero-module--heroImage--3qKa6";
export var leftPart = "hero-module--leftPart--27rI_";
export var socialButtons = "hero-module--socialButtons--1XJRj";
export var buttonContainer = "hero-module--buttonContainer--e6TH3";
export var seeMyWork = "hero-module--seeMyWork--1uYjh";
export var getMyResume = "hero-module--getMyResume--3G8Lg";